import { render } from "./App.vue?vue&type=template&id=71d68664"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=71d68664&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\api_adm_unimagem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__